import { Box, Spinner } from '@hivewatch/dark'

export const WorkflowLoadingSpinner = (): JSX.Element => (
  <Box alignItems='center' display='flex' justifyContent='center' py='32px'>
    <Spinner size='md' />
  </Box>
)
